import { useState } from 'react';
import Box from '@mui/material/Box';
import { alpha } from '@mui/material';
import Button from 'core/buttons/Button';
import { useNavigate } from 'react-router-dom';
import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';
import ArrowForwardTwoToneIcon from '@mui/icons-material/ArrowForwardTwoTone';

import { buildRoute } from 'routes';
import useInterval from 'hooks/useInterval';

const Wrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  height: '100vh',
  width: '100vw',
  backgroundColor: alpha(theme.palette.grey[800], 0.8),
  top: 0,
  right: 0,
  zIndex: 1200,
  display: 'grid',
  placeItems: 'center'
}));

const Container = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  padding: theme.spacing(3),
  borderRadius: theme.spacing(0.5),
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  textAlign: 'center'
}));

export default function PasswordResetSuccess() {
  const [timer, setTimer] = useState(10);

  useInterval(() => {
    if (timer !== 0) setTimer(timer - 1);
    if (timer <= 0) redirectToLogin();
  }, [1000]);

  const redirectToLogin = () => (window.location.href = buildRoute('login'));

  return (
    <Wrapper>
      <Container>
        <Box>
          <Typography variant="h6" color="success.main">
            Password reset successful!
          </Typography>
          <Typography variant="subtitle1">
            Redirecting to &nbsp;
            <a
              style={{
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
              onClick={redirectToLogin}
            >
              <strong>Login</strong>
            </a>
            &nbsp; in <strong>{timer}</strong>s
          </Typography>
        </Box>
        <Box sx={{ width: '100%' }} display="flex" justifyContent="center">
          <Button
            onClick={redirectToLogin}
            size="large"
            variant="outlined"
            sx={{ textTransform: 'none' }}
            endIcon={<ArrowForwardTwoToneIcon />}
          >
            Continue
          </Button>
        </Box>
      </Container>
    </Wrapper>
  );
}
